// extracted by css-extract-rspack-plugin
export default {"Box":"repo-picker-module__Box__k6AGv","Text":"repo-picker-module__Text__EqsWJ","Text_1":"repo-picker-module__Text_1__hbpkw"};